import { createWebQueryClient } from '@citylytics/web-api-client/query-client/service';

let _queryClient: ReturnType<typeof createWebQueryClient> | null = null;

export function getQueryClient() {
  if (!_queryClient) {
    _queryClient = createWebQueryClient();
  }

  return _queryClient;
}
